module.exports = __webpack_public_path__ + "static/media/france.968aaa24.svg";